import Vue from 'vue'
import Vuex from 'vuex'
import {getSearchUser} from '@/api/cq-api'
Vue.use(Vuex)

const store = new Vuex.Store({
  // 定义状态
  state: {
    order: '',
    price: '',
    centerDialogVisible: "",
    LiveMsg:[],
  },
  mutations: {
    OrderList(state, msg) {
      state.order = msg
    },
    changeMsg(state,res){
      if(res.message.type == 2){
          let obj = {
            sourceMsg:res.message.message.sourceMsg,
            id:res.message.message.id,
            from:res.result,
            type:2
          }
          state.LiveMsg.push(obj) 
      }
      if(res.type == 1){
          let obj = {
              sourceMsg:res.message,
              id:res.id,
              from:'',
              type:1
          } 
          state.LiveMsg.push(obj) 
      }  
    },
    // changeCourseMsg(state,res){
    //   if(res.message.type == 2){
    //       let obj = {
    //         sourceMsg:res.message.message.sourceMsg,
    //         id:res.message.message.id,
    //         from:res.result,
    //         type:2
    //       }
    //       state.courseLiveMsg.push(obj)
    //   }
    //   if(res.type == 1){
    //       let obj = {
    //           sourceMsg:res.message,
    //           id:res.id,
    //           from:'',
    //           type:1
    //       }  
    //       state.courseLiveMsg.push(obj)
    //   }  
    // },
  },
  actions:{
    setChangeMsg({commit},formData){
      if(formData.type == 2){
        getSearchUser({userImAccount:formData.message.from}).then(res => {
          if(res.msg == 'success'){
            commit('changeMsg',{message:formData,result:res.data.nickName})
          }  
        })
      }else{
        commit('changeMsg',formData)
      }  
    },
    // setCourseChangeMsg({commit},formData){
    //   if(formData.type == 2){
    //     getSearchUser({userImAccount:formData.message.from}).then(res => {
    //       if(res.msg == 'success'){
    //         commit('changeCourseMsg',{message:formData,result:res.data.nickName})
    //       }  
    //     })
    //   }else{
    //     commit('changeCourseMsg',formData)
    //   }  
    // }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/vuex/store.js